var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.showType === 'iframe'),expression:"showType === 'iframe'"}],attrs:{"src":"","frameborder":"0","id":"iframe","width":"100%","height":"100%"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05c88070","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Iframe/index.vue
// module id = null
// module chunks = 